import { gql } from '@apollo/client';

/**
 * ТЗ 0080 — одна короткая ссылка: строка списка и карточка.
 *
 * Один фрагмент на список, карточку и КАЖДУЮ мутацию, которая возвращает
 * `link`: ответ мутации обязан обновить ту же запись кэша (`ShortLinkType:id`),
 * из которой читают строка таблицы и карточка, — иначе после «Погасить» статус
 * оставался бы прежним до перезагрузки.
 *
 * 🔴 У ссылки на подпись договора (`kind: "contract"`) `code`, `url`,
 * `targetUrl` и `targetHost` — null по замыслу бэкенда: это bearer-секрет.
 * Раскрывают её только из карточки договора (с записью в журнал).
 *
 * `channel` — тип ссылки (код из списка ERP или свой текст, `''` — не
 * указан), `tags` — метки; у ссылки на подпись оба пусты.
 */
export const SHORT_LINK_FIELDS = gql`
  fragment ShortLinkFields on ShortLinkType {
    id
    kind
    title
    channel
    tags
    code
    url
    targetUrl
    targetHost
    subjectKind
    subjectId
    subjectLabel
    leadId
    candidateId
    clickCount
    humanClickCount
    firstHumanClickedAt
    lastClickedAt
    expiresAt
    revokedAt
    createdAt
    createdByName
    state
    canEdit
    canRevoke
  }
`;
